export const TreatmentProvince = [
  {
    name: "تهران",
    value: "tehran",

    cities: [
      "تهران",
      "پردیس",
      "بهارستان دو",
      "بهارستان یک ",
      "اسلامشهر",
      "چهاردانگه",
      "پیشوا",
      "فیروزکوه",
      "رودهن",
      "دماوند",
      "پاکدشت",
      "جوادآباد",
      "قرچک",
      "ورامین",
      "رباط کریم",
      "ملارد",
      "شهریار",
      "شهرری",
      "شهرقدس",
      "کهریزک",
      "فشافویه ",
    ],
  },

  {
    name: "مرکزی",
    value: "markazi",

    cities: [
      "سربند",
      "شازند",
      "دلیجان",
      "محلات",
      "خمین",
      "نوبران",
      "زرندیه",
      "ساوه",
      "فراهان",
      "تفرش",
      "آشتیان",
      "خنداب",
      "کمیجان",
      "اراک",
    ],
  },

  {
    name: "خراسان رضوی",
    value: "khorasan_razavi",

    cities: [
      "خليل آباد",
      "كدكن",
      "مه ولات",
      "سرولايت",
      "نيشابور",
      "جلگه رخ",
      "بجستان",
      "گناباد",
      "بردسکن",
      "كوهسرخ",
      "كاشمر",
      "داورزن",
      "قوچان",
      "باخرز",
      "فیروزه",
      "جوين",
      "جغتاي",
      "زبرخان",
      "ششتمد",
      "سبزوار",
      "نوخندان",
      "درگز",
      "خواف",
      "ميان جلگه",
      "گلبهار",
      "رشتخوار",
      "زاوه",
      "تربت حیدریه ",
      "صالح آباد",
      "تربت جام",
      "تايباد",
      "رضويه",
      "مشهد",
      "سرخس",
      "خوشاب",
      "چناران",
      "كلات",
      "فريمان",
      "طرقبه",
      "تبادكان",
      "احمدآباد",
    ],
  },

  {
    name: "اصفهان",
    value: "esfahan",
    cities: [
      "بادرود",
      "زواره",
      "بن رود",
      "جلگه",
      "نطنز",
      "مهردشت",
      "پیربکران",
      "آران و بیدگل",
      "کاشان",
      "خمینی شهر",
      "تیران و کرون",
      "نجف آباد",
      "خور و بیابانک",
      "نائین",
      "گلپایگان",
      "خوانسار",
      "سمیرم",
      "فریدونشهر",
      "فلاورجان",
      "بوئین میاندشت",
      "چادگان",
      "فریدن",
      "دهاقان",
      "شهرضا",
      "باغبهادران",
      "مبارکه",
      "اصفهان",
      "فولاد شهر",
      "زرین شهر",
      "اردستان",
      "برخوار",
      "میمه",
      "شاهین شهر",
      "جرقویه علیا",
      "کوهپایه",
      "جرقویه سفلی",
    ],
  },

  {
    name: "آذربایجان شرقی",
    value: "azarbayejan_sharghi",

    cities: [
      "ایلخچی",
      "نظركهريز",
      "تیکمه داش",
      "عشایر",
      "چاراوایماق",
      "هشترود",
      "نظرکهریزی",
      "ترکمانچای ",
      "کندوان",
      "میانه",
      "تسوج",
      "جلفا",
      "مرند",
      "ملکان",
      "بناب",
      "عجب شیر",
      "مراغه",
      "سراب",
      "کلیبر",
      "کاغذ کنان",
      "خدآفرین",
      "خاروانا",
      "ورزقان",
      "هوراند",
      "اهر",
      "گوگان",
      "خسروشاه",
      "خواجه",
      "مهربان",
      "هریس",
      "صوفیان",
      "شبستر",
      "بستان آباد",
      "آذرشهر",
      "اسکو",
      "تبریز",
    ],
  },

  {
    name: "اردبیل",
    value: "ardebil",

    cities: [
      "لاهرود",
      "سرعين",
      "جعفر آباد",
      "ارشق",
      "انگوت",
      "هیر",
      "مشگین شهر",
      "اصلاندوز",
      "بیله سوار",
      "پارس آباد",
      "گرمی",
      "کوثر",
      "شاهرود",
      "خورش رستم",
      "خلخال",
      "نمین",
      "نیر",
      "اردبیل",
    ],
  },

  {
    name: "مازندران",
    value: "mazandaran",

    cities: [
      "کلاردشت",
      "چالوس",
      "نوشهر",
      "مرزن آباد",
      "بلده",
      "چمستان",
      "کجور",
      "نور",
      "سوادکوه شمالی",
      "سوادکوه",
      "رامسر",
      "عباس آباد",
      "تنکابن",
      "جویبار",
      "سیمرغ",
      "قائمشهر",
      "نکا",
      "گلوگاه",
      "بهشهر",
      "فریدونکنار",
      "بهنمیر",
      "بابلسر",
      "بندپی غربی",
      "بندپی شرقی",
      "بابل",
      "محمودآباد",
      "لاریجان",
      "آمل",
      "چهاردانگه",
      "میاندورود",
      "دودانگه",
      "ساری",
    ],
  },

  {
    name: "خراسان شمالی",
    value: "khorasan_shomali",

    cities: [
      "فاروج",
      "شیروان",
      "بام و صفی آباد",
      "مانه و سملقان",
      "راز و جرگلان",
      "گرمه",
      "جاجرم",
      "اسفراین",
      "بجنورد",
    ],
  },

  {
    name: "خراسان جنوبی",
    value: "khorasan_jonobi",

    cities: [
      "دستگردان",
      "طبس",
      "خوسف",
      "قائن",
      "سرایان",
      "بشرویه",
      "فردوس",
      "زیرکوه",
      "نهبندان",
      "اسدیه",
      "سربیشه",
      "بیرجند",
    ],
  },

  {
    name: "فارس",
    value: "fars",

    cities: [
      "مشهدمرغاب (قادرآباد)",
      "میمند",
      "فرگ",
      "آباده طشک",
      "عشایری فارس",
      "نی ریز",
      "علامرودشت",
      "اشکنان",
      "بابامنیرماهورمیلاتی",
      "رستم",
      "ممسنی",
      "درودزن",
      "پاسارگاد",
      "ارسنجان",
      "کامفیروز",
      "مرودشت",
      "مهر",
      "لامرد",
      "خنج",
      "اوز",
      "گراش",
      "جویم",
      "بیرم",
      "لارستان",
      "گله دار",
      "قایمیه",
      "کهمره",
      "خشت وکمارج",
      "بالاده",
      "کازرون",
      "قیروکارزین",
      "فراشبند",
      "فیروزآباد",
      "شیب کوه",
      "ششده وقره بلاغ",
      "فسا",
      "بیضا",
      "سپیدان",
      "زرین دشت",
      "داراب",
      "خفر",
      "جهرم",
      "استهبان",
      "سده",
      "اقلید",
      "سرچهان",
      "بوانات",
      "خرم بید",
      "آباده",
      "ارژن (کوهمره سرخی )",
      "کوار",
      "سروستان",
      "زرقان",
      "خرامه",
      "دشمن زیاری",
      "شیراز",
    ],
  },

  {
    name: "البرز",
    value: "alborz",

    cities: ["اشتهارد", "نظرآباد", "طالقان ", "ساوجبلاغ", "کرج"],
  },
  {
    name: "قم",
    value: "qom",

    cities: ["قم", "جعفر آباد", "کهک", "خلجستان"],
  },

  {
    name: "گلستان",
    value: "golestan",

    cities: [
      "آزادشهر",
      "آق قلا",
      "گرگان",
      "کلاله",
      "مراوه تپه",
      "گالیکش",
      "مینودشت",
      "رامیان",
      "گنبد",
      "بندرگز",
      "کردکوی",
      "علی اباد",
      "گمیشان",
      "بندرترکمن",
    ],
  },

  {
    name: "آذربایجان غربی",
    value: "azarbayejan_gharbi",

    cities: [
      "منطقه نازلو",
      "منطقه صومای برادوست",
      "كشاورز",
      "منطقه مرحمت آباد",
      "منطقه سیلوانا",
      "اشنویه",
      "نقده",
      "سردشت",
      "پیرانشهر",
      "تکاب",
      "شاهین دژ",
      "مياندوآب",
      "بوکان",
      "مهاباد",
      "سلماس",
      "چالدران",
      "پلدشت",
      "شوط ",
      "ماکو ",
      "چایپاره",
      "خوی",
      "منطقه انزل",
      "ارومیه",
    ],
  },

  {
    name: "چهارمحال وبختیاری",
    value: "chaharmalah",

    cities: [
      "عشایر",
      "بلداجی ",
      "خانمیرزا",
      "گندمان ",
      "میانکوه",
      "بن",
      "سامان",
      "لاران",
      "فلارد",
      "لردگان",
      "کوهرنگ",
      "فارسان",
      "اردل",
      "بروجن",
      "کیار",
      "شهرکرد",
    ],
  },

  {
    name: "ایلام",
    value: "ilam",

    cities: [
      "موسیان",
      "هلیلان",
      "زرین آباد",
      "چوار",
      "بدره",
      "ارکواز ملکشاهی",
      "مهران",
      "سیروان",
      "چرداول",
      "دهلران",
      "آبدانان",
      "دره شهر",
      "ایوان",
      "ایلام ",
    ],
  },

  {
    name: "کرمانشاه",
    value: "kermanshah",

    cities: [
      "گواور",
      "بیستون",
      "گهواره",
      "حمیل",
      "دینور",
      "باینگان",
      "گیلانغرب",
      "دالاهو",
      "ماهیدشت",
      "اسلام آبادغرب",
      "ثلاث باباجانی ",
      "روانسر ",
      "جوانرود",
      "سنقر",
      "نوسود",
      "پاوه",
      "سرپل ذهاب ",
      "قصرشیرین",
      "کنگاور",
      "هرسین",
      "صحنه",
      "کرمانشاه",
    ],
  },

  {
    name: "خوزستان",
    value: "khozestan",

    cities: [
      "حمیدیه",
      "کرخه",
      "الوارگرمسیری",
      "عشايرى",
      "سردشت",
      "عشایر",
      "اندیکا",
      "امیدیه",
      "گتوند",
      "شوشتر",
      "هفتکل",
      "لالی",
      "مسجدسلیمان",
      "هندیجان",
      "بندرامام",
      "بندرماهشهر",
      "شادگان",
      "رامشیر",
      "رامهرمز",
      "هویزه",
      "بستان",
      "دشت آزادگان",
      "اندیمشک",
      "شوش",
      "دزفول",
      "خرمشهر",
      "آغاجاری",
      "زیدون",
      "بهبهان",
      "صیدون",
      "باغملک",
      "دژپارت",
      "ایذه",
      "اروندکنار",
      "آبادان",
      "باوی",
      "کارون",
      "اهواز",
    ],
  },

  {
    name: "گیلان",
    value: "gilan",

    cities: [
      "حویق ",
      "چابکسر",
      "رودبنه",
      "اطاقور",
      "رحمت آباد",
      "کومله",
      "آستارا",
      "عمارلو",
      "رودبار",
      "لنگرود",
      "کیاشهر",
      "آستانه اشرفیه",
      "تولمات",
      "صومعه سرا",
      "شفت",
      "ماسال وشاندرمن",
      "فومن",
      "رضوانشهر",
      "تالش",
      "رحیم آباد",
      "املش",
      "کلاچای",
      "رودسر",
      "دیلمان",
      "سیاهکل",
      "لاهیجان ",
      "بندر انزلی",
      "سنگر",
      "لشت نشا ء",
      "کوچصفهان",
      "خشکبیجار",
      "خمام",
      "رشت",
    ],
  },

  {
    name: "کرمان",
    value: "kerman",

    cities: [
      "عشایرسیار",
      "نوق",
      "فهرج",
      "چترود",
      "جازموریان",
      "عنبرآباد",
      "کوهبنان",
      "زرند",
      "قلعه گنج",
      "منوجان",
      "ریگان",
      "کهنوج",
      "فاریاب",
      "رابر",
      "ارزوئیه",
      "بافت",
      "شهربابک",
      "بردسیر",
      "سیرجان",
      "نرماشیر",
      "راین",
      "بم",
      "انار",
      "رفسنجان",
      "کشکوئیه",
      "جیرفت",
      "ماهان",
      "گلباف",
      "شهداد",
      "راور",
      "رودبار",
      "کرمان",
    ],
  },

  {
    name: "کهگیلویه و بویراحمد",
    value: "kohgloyie",

    cities: [
      "یاسوج",
      "دیشموک",
      "لوداب",
      "مارگون",
      "چاروسا",
      "باشت",
      "گچساران",
      "بهمئي",
      "چرام",
      "لنده",
      "دهدشت",
      "دنا",
    ],
  },

  {
    name: "یزد",
    value: "yazd",

    cities: [
      "مروست",
      "زارچ",
      "خاتم",
      "مهریز",
      "ابرکوه",
      "نیر",
      "تفت",
      "بهاباد",
      "بافق",
      "میبد",
      "اردکان",
      "اشکذر",
      "یزد",
    ],
  },

  {
    name: "قزوین",
    value: "qazvin",

    cities: [
      "قزوین",
      "شال",
      "اسفرورین",
      "البرز",
      "خرمدشت",
      "طارم سفلی",
      "الموت غربی",
      "الموت شرقی",
      "بویین زهرا",
      "آوج",
      "آبیک",
      "قزوین",
      "قزوین",
      "ضیاآباد",
      "تاکستان",
    ],
  },

  {
    name: "سیستان و بلوچستان",
    value: "sistan_balouchestan",

    cities: [
      "عشایر",
      "بم پشت",
      "بنت",
      "دلگان",
      "تفتان",
      "جالق",
      "نصرت آباد",
      "میرجاوه",
      "دشتیاری",
      "مهرستان",
      "سیب و سوران",
      "سراوان",
      "خاش",
      "کنارک",
      "چابهار",
      "قصرقند",
      "نیکشهر",
      "راسک",
      "سرباز",
      "بزمان",
      "فنوج",
      "لاشار",
      "بمپور",
      "ایرانشهر",
      "هیرمند",
      "زهک",
      "زرآباد",
      "هامون",
      "پلان",
      "بنجار",
      "نیمروز",
      "زابل",
      "زاهدان",
    ],
  },

  {
    name: "هرمزگان",
    value: "hormozgan",

    cities: [
      "جناح",
      "هرمز",
      "شهاب",
      "سندرک",
      "ابوموسی",
      "کیش",
      "رودخانه",
      "رودان",
      "بشاگرد",
      "میناب",
      "سیریک",
      "قشم",
      "پارسیان",
      "بستک",
      "لنگه",
      "شیبکوه",
      "جاسک",
      "حاجی آباد",
      "فین",
      "خمیر",
      "بندرعباس",
    ],
  },

  {
    name: "بوشهر",
    value: "boushehr",

    cities: [
      "عسلویه",
      "بردخون",
      "دیر",
      "جم",
      "کنگان",
      "آبپخش",
      "دشتی",
      "دلوار",
      "تنگستان",
      "شبانکاره",
      "سعدآباد",
      "دشتستان",
      "دیلم",
      "بندر ریگ",
      "کاکی",
      "گناوه",
      "خارک",
      "بوشهر",
    ],
  },

  {
    name: "لرستان",
    value: "lorestan",

    cities: [
      "عشايري",
      "كاكاوند",
      "كوهناني",
      "ززوماهرو",
      "معمولان",
      "بیرانشهر",
      "رومشگان",
      "سيلاخور",
      "دورود",
      "اشترينان",
      "بروجرد",
      "ازنا",
      "اليگودرز",
      "طرحان",
      "کوهدشت",
      "نورآباد",
      "ويسيان",
      "پلدختر",
      "زاغه",
      "چگني",
      "الشتر",
      "پاپي",
      "سپید دشت",
      "خرم آباد",
    ],
  },

  {
    name: "همدان",
    value: "hamedan",

    cities: [
      "لالجین",
      "فرسفج(قلقلرود)",
      "درگزین",
      "گل تپه",
      "جوکار",
      "خزل",
      "نهاوند",
      "تویسرکان",
      "فیروزان ",
      "سامن",
      "ملایر",
      "کبود راهنگ",
      "بهار ",
      "دمق سردرود",
      "رزن",
      "قهاوند",
      "فامنین ",
      "اسدآباد",
      "همدان",
    ],
  },

  {
    name: "زنجان",
    value: "zanjan",

    cities: [
      "سجاسرود",
      "انگوران",
      "بزینه رود",
      "ایجرود",
      "زنجانرود",
      "افشار",
      "خدابنده",
      "سلطانیه",
      "خرم دره",
      "ابهر",
      "ماهنشان",
      "طارم",
      "زنجان",
    ],
  },

  {
    name: "کردستان",
    value: "kordestan",

    cities: [
      "سریش آباد",
      "کلاترزان",
      "زیویه",
      "موچش",
      "کرانی",
      "سروآباد",
      "مریوان",
      "دهگلان",
      "قروه",
      "سقز",
      "بیجار",
      "بانه",
      "کامیاران",
      "دیواندره",
      "سنندج",
    ],
  },

  {
    name: "سمنان",
    value: "semnan",

    cities: [
      "آرادان",
      "سرخه",
      "بیارجمند",
      "گرمسار",
      "امیرآباد",
      "دامغان",
      "میامی",
      "بسطام",
      "شاهرود",
      "مهدیشهر",
      "سمنان",
    ],
  },
];
